import { createStore } from '@souche-f2e/muji';
import { message, notification } from 'antd';
import Api from '@/services';
const initState = {
    title: '',
    bannerName: '',
    link: '',
    bannerPicUrl: '',
    previewVisible: false,
    previewImage: '',
};
export default createStore({
    state: Object.assign({}, initState),
    effects: {
        /**
         *  轮播图详情
         */
        getBannerInfo(payload, { update, state, rootState }) {
            Api.system.watchBanner(payload).then((data) => {
                this.SET_STATE(Object.assign(Object.assign({}, data), { bannerPicUrl: data.picturePath }));
            });
        },
        /**
         * 依据props.type处理title
         */
        dealProps(payload, { update, state, rootState }) {
            const { type, id } = payload;
            let title;
            switch (Number(type)) {
                case 0:
                    title = '新建App轮播图';
                    this.RESET_STATE();
                    break;
                case 1:
                    title = '编辑App轮播图';
                    this.RESET_STATE();
                    this.getBannerInfo({ id });
                    break;
                case 2:
                    title = '查看App轮播图';
                    this.RESET_STATE();
                    this.getBannerInfo({ id });
                    break;
                default:
                    console.warn('请输入正确的轮播图类型');
                    return;
            }
            this.SET_STATE({ title });
        },
        /**
         *  点击确定
         */
        handleOk(payload, { update, state, rootState }) {
            payload.form.validateFields((e, v) => {
                if (e !== null) {
                    message.error('请填写完成信息');
                }
                else if (!state.bannerPicUrl) {
                    message.error('请上传图片');
                }
                else {
                    // 轮播图信息
                    const bannerInfo = {
                        picturePath: state.bannerPicUrl,
                        link: v.link,
                        bannerName: v.bannerName,
                        id: payload.id ? payload.id : '',
                    };
                    Api.system.createBanner(bannerInfo).then((data) => {
                        if (data && payload.onOk) {
                            notification.success({ message: '保存成功' });
                            payload.onOk();
                        }
                    });
                }
            });
        },
        /**
         *  点击取消或叉号
         */
        handleCancel(payload, { update, state, rootState }) {
            payload.form.resetFields();
            if (payload.onCancel) {
                payload.onCancel();
            }
        },
    },
    reducers: {
        RESET_STATE() {
            return Object.assign({}, initState);
        },
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                if (initState[key] !== undefined) {
                    state[key] = payload[key];
                }
            });
        },
    },
});
